<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="row">
					<div class="col-lg-9">
						<div class="row">
							<div class="col-lg-3">
                    		    <label >Código Empresa </label>
                    		    <input type="text" v-model="Equipo.Codigo" class="form-control" placeholder="Código Empresa" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Codigo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
                    		    <label >Código Fabricante </label>
                    		    <input type="text" v-model="Equipo.CodigoFabricante" class="form-control" placeholder="Código Fabricante" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.CodigoFabricante" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
                    		    <label >Ítem </label>
                    		    <input type="text" v-model="Equipo.Item" class="form-control" placeholder="Ítem" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
                    		    <label >Sub Ítem </label>
                    		    <input type="text" v-model="Equipo.SubItem" class="form-control" placeholder="Ítem" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.SubItem" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
								<label for="">Unidad</label>
								<input type="text" class="form-control" v-model="Equipo.Unidad" placeholder="Unidad">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="this.errorvalidacion.Unidad[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
                    		    <label >Marca </label>
                    		    <input type="text" v-model="Equipo.Marca" class="form-control" placeholder="Marca" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Marca" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
                    		    <label >Modelo </label>
                    		    <input type="text" v-model="Equipo.Modelo" class="form-control" placeholder="Modelo" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Modelo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
                    		    <label >Costo Unitario</label>
                    		    <vue-numeric placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="Equipo.Precio"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Precio" :Mensaje="this.errorvalidacion.Precio[1]"></Cvalidation></label>
                    		</div>
						</div>
						<div class="row">
							<div class="col-lg-2">
								<label for="">Stock</label>
								<input @input="CambiarFechaStock" type="number" class="form-control" v-model="Equipo.Stock" placeholder="Stock">
								<!-- <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Stock" :Mensaje="this.errorvalidacion.Stock[0]"></Cvalidation></label> -->
							</div>
							<div class="col-lg-3">
                    		    <label for="">Fecha Stock</label>
                    		    <v-date-picker v-model="Equipo.FechaStock" :mode="typeCalendar"
                    		        :popover="{
                    		            placement: 'bottom',
                    		            visibility: 'click'
                    		        }"
                    		        :input-props="{
                    		            class: 'form-control cal-black',
                    		            style: 'cursor:pointer;'
                    		        }"
                    		        :locale="'es-MX'"
                    		    >
									<template v-slot="{ inputValue, inputEvents }">
										<input type="text" disabled="true" :value="inputValue" class="form-control calendar" style="cursor:pointer;background-color:#F9F9F9"
                    		        	v-on="inputEvents">
									</template>
								</v-date-picker>
                    		</div>
						</div>
					</div>
					<div class="col-lg-3">
						<div class="row">
							<div class="col-lg-12">
								<div class="avatar-upload almacen-upload">
									<div class="avatar-edit">
										<input
											id="file"
											ref="file"
											type="file"
											name="myfile"
											@change="uploadImage()"
											accept=".png, .jpg, .jpeg"
										/>
										<label for="file"></label>
									</div>
									<div class="avatar-preview imagenes-almacen">
										<div
											id="imagePreview"
											style="background-image: url(Img);"
										></div>
									</div>
								</div>
								<label class="ml-5 pl-3 mt-2">Recomendada 400 x 400</label>
							</div>
						</div>
					</div>
                    <!--fin col-6-->
                </div>
				<div class="row mt-3">
					<div class="col-lg-12">
						<label for="">Descripción</label>
						<textarea v-model="Equipo.Nombre" cols="30" rows="2" class="form-control" placeholder="Descripción"></textarea>
					</div>
				</div>
				<!-- <div class="row mt-2">
					<div class="col-lg-12">
						<label for="">Movimientos</label>
						<textarea v-model="Equipo.Movimientos" cols="30" rows="2" class="form-control" placeholder="Movimientos"></textarea>
					</div>
				</div> -->
				<div class="mt-3" v-if="Equipo.IdEquipoCot>0">
					<ListForm :ShowButtonTop="DatosTablaProveedor.ShowButtonTop"
					:ShowButton="true"
					:NombreTabla="DatosTablaProveedor.NombreTabla"
					:EmitSeccionTabla="DatosTablaProveedor.EmitSeccionTabla"
                    :TituloBoton="DatosTablaProveedor.TituloBoton"
                    :pConfigLoad="DatosTablaProveedor.ConfigLoad"
					:pShowPager="true">
						<template slot="header_table_form">
							<th>Proveedor</th>
							<th>N° Parte Proveedor</th>
							<th>Precio de Lista</th>
							<th>Última Cotización</th>
							<th>Nombre Contacto</th>
							<th>Tipo de Contacto</th>
							<th>Acciones</th>
						</template>
						<template slot="body_table_form">
							<tr v-for="(item,index) in Proveedores" :key="index">
								<td>{{item.Proveedor}}</td>
								<td>{{item.NoParteProveedor}}</td>
								<td>$ {{Number(item.Precio).toLocaleString('es-MX') }}</td>
								<td class="p-0"><i class="fa fa-calendar"></i> {{$getCleanDate(item.UltimaCotizacion,false)}}</td>
								<td>{{item.NombreContacto}}</td>
								<td>{{item.TipoContacto}}</td>
								<td colspan="2"><Cbtnaccion :isModal="true" 
                                    :pEmitSeccion="DatosTablaProveedor.EmitSeccionTabla" 
                                    :Id="item.IdEquipoCotProveedor"
                                    :IrA="DatosTablaProveedor.TituloBoton">

									</Cbtnaccion>
								</td>
							</tr>
						</template>
					</ListForm>
				</div>
                <!--Fin body del panel-->
            </template>
        </CLoader>
		<Modal 
            :NameModal="DatosTablaProveedor.TituloBoton" 
            :size="'modal-lg'" 
            :Nombre="DatosTablaProveedor.TituloBoton" 
            :pEmitSeccion="DatosTablaProveedor.EmitSeccionTabla"
            :poBtnSave="DatosTablaProveedor.oBtnSave"
        >
            <template slot="Form">
                <FormProveedores :poBtnSave="DatosTablaProveedor.oBtnSave" :IdEquipoCot="Equipo.IdEquipoCot"></FormProveedores>
            </template>
        </Modal>

    </div>

</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Clist from '@/components/Clist.vue';
import Cvalidation from '@/components/Cvalidation.vue'
import ListForm from '@/components/Clistform.vue';
import Cbtnaccion from "@/components/Cbtnaccion.vue";
import Modal from '@/components/Cmodal.vue';
import FormProveedores from '../equipos/proveedores/Form.vue';
import $$ from "jquery";

export default {
    name:'Form',
    props:['NameList','poBtnSave','pTipo'],
    data() {
        return {
            Modal:true,//Sirve pra los botones de guardado
            FormName:'Equipo',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            Equipo:{            
                IdEquipoCot:0,
                Codigo:"S/N",
                Nombre:"",
				Marca:"",
				Modelo:"",
                Precio:"",
				Item:"",
				Unidad:"",
				Stock:0,
				Movimientos:"",
				FechaStock:"",
				CodigoFabricante:"",
				Imagen:"",
				SubItem:"",
				Tipo:0
            },
			Imagen:"",
            urlApi:"cotizacion_equipo/recovery",
            errorvalidacion:[],
			EmitSeccion:this.poBtnSave.EmitSeccion,
			FechaStockOriginal:"",
			StockOriginal:"",
			DatosTablaProveedor:{
				ConfigLoad:{
                    ShowLoader:true,
                    ClassLoad:true
                },
				ShowButtonTop:false,
                ShowButton:true,
				NombreTabla:"Proveedores",
				EmitSeccionTabla:"Proveedores",
				TituloBoton:"Proveedores",
				oBtnSave:{
                	isModal:true,
                	disableBtn:false,
                	toast:0,
                	nombreModal:"Proveedores",
                	EmitSeccion:"Proveedores"
            	},
				Filtros:{
					TotalItem:0,
                	Pagina:1,
                	Entrada:5,
				}
			},
			Proveedores:[]
        }
    },
    components:{
        Cbtnsave,
        Clist,Cvalidation,Modal,ListForm,FormProveedores,Cbtnaccion
    },
    methods :
    {
    
       async Guardar()
        {
             //deshabilita botones
            this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			let formData=new FormData();
			formData.set('IdEquipoCot',this.Equipo.IdEquipoCot);
			formData.set('Codigo',this.Equipo.Codigo);
			formData.set('Nombre',this.Equipo.Nombre);
			formData.set('Marca',this.Equipo.Marca);
			formData.set('Modelo',this.Equipo.Modelo);
			formData.set('Precio',this.Equipo.Precio);
			formData.set('Item',this.Equipo.Item);
			formData.set('SubItem',this.Equipo.SubItem);
			formData.set('Tipo',this.Equipo.Tipo);
			formData.set('Unidad',this.Equipo.Unidad);
			formData.set('Stock',this.Equipo.Stock);
			formData.set('Movimientos',this.Equipo.Movimientos);
			formData.set('FechaStock',this.Equipo.FechaStock);
			formData.set('CodigoFabricante',this.Equipo.CodigoFabricante);
			formData.set('Imagen',this.Equipo.Imagen);
			let file = this.$refs.file.files[0];
			formData.append("ImagenFile", file);
            await this.$http.post(
                'cotizacion_equipo/post',
                formData,
				{
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then( (res) => {
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
                this.bus.$emit('List_'+this.EmitSeccion);

            }).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;  

            });
       
        },
         Limpiar()
        {
            this.Equipo.IdEquipoCot=0;
            this.Equipo.Nombre="";
			this.Equipo.Marca="";
			this.Equipo.Modelo="";
            this.Equipo.Codigo="S/N";
            this.Equipo.Precio="";
			this.Equipo.Item="";
			this.Equipo.SubItem="";
			this.Equipo.Unidad="";
			this.Equipo.Movimientos="";
			this.Equipo.Stock=0;
			this.Equipo.FechaStock='';
			this.Equipo.CodigoFabricante='';
			this.Equipo.Imagen='';
			this.Equipo.Tipo=0;
			this.StockOriginal=0;
			this.FechaStockOriginal=new Date();
            this.errorvalidacion=[];
			this.Imagen="";
			const input = this.$refs.file;
			input.type = 'text'
            input.type = 'file';
			this.readURL(this.Imagen);
            
        },
        get_one()
        {
            this.$http.get(
                this.urlApi,
                {
                    params:{IdEquipoCot: this.Equipo.IdEquipoCot}
                }
            ).then( (res) => {
                this.Equipo=res.data.data.equipocot;
				let Foto=res.data.data.equipocot.Imagen;
				if (Foto != "" && Foto != null) {
					this.Imagen = res.data.data.ruta + this.Equipo.Imagen;
				}
				this.readURL(this.Imagen);
				if (res.data.data.equipocot.FechaStock!=null) {
					let formatedDate = res.data.data.equipocot.FechaStock.replace(/-/g, "\/");
                	this.Equipo.FechaStock=new Date(formatedDate)
					this.FechaStockOriginal=new Date(formatedDate);	
				}
				else{
					this.Equipo.FechaStock=new Date();
					this.FechaStockOriginal=new Date();
				}
				this.StockOriginal=res.data.data.equipocot.Stock;
				this.GetEquipoProveedor();
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		async GetEquipoProveedor(){
			this.DatosTablaProveedor.ConfigLoad.ShowLoader=true;
			await this.$http.get('equipocotproveedor/get',{
                params:{
                    IdEquipoCot:this.Equipo.IdEquipoCot,
					Entrada:this.DatosTablaProveedor.Filtros.Entrada,
					pag:this.DatosTablaProveedor.Filtros.Pagina
                }
            }).then((res)=>{
                this.Proveedores=res.data.data.equipocotproveedor;
				this.DatosTablaProveedor.Filtros.Entrada=res.data.data.pagination.PageSize;
				this.DatosTablaProveedor.Filtros.TotalItem=res.data.data.pagination.TotalItems;
                // this.UrlDocumentos=res.data.data.urlarchivos;
            }).finally(()=>{
                this.DatosTablaProveedor.ConfigLoad.ShowLoader=false;
            })
		},
		BorrarProveedor(Id){
			this.$swal({
                title: 'Esta seguro que desea eliminar este dato?',
                text: 'No se podra revertir esta acción',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si',
                cancelButtonText: 'No, mantener',
                showCloseButton: true,
                showLoaderOnConfirm: true
            }).then((result)=>{
                if(result.value){
                    this.$http.delete(
                        'equipocotproveedor/'+Id
                    ).then((res)=>{
                        this.$toast.success('Información eliminada');
                        this.GetEquipoProveedor();
                    })
                }
            })
		},
		CambiarFechaStock(){
			if (this.Equipo.Stock!=this.StockOriginal) {
				this.Equipo.FechaStock=new Date();
			}
			else{
				this.Equipo.FechaStock=this.FechaStockOriginal;
			}
		},
		uploadImage() {
			this.Equipo.Imagen = this.$refs.file.files[0];
			const image = this.$refs.file.files[0];
			const reader = new FileReader();
			var img = "";
			reader.readAsDataURL(image);

			reader.onload = e => {
				this.Imagen = e.target.result;
				this.readURL(this.Imagen);
			};
		},
		readURL(input) {
			$$("#imagePreview").css("background-image", "url(" + this.Imagen + ")");
			$$("#imagePreview").hide();
			$$("#imagePreview").fadeIn(650);
		},

    },
    created() {
        
        this.bus.$off('Save_'+this.EmitSeccion);
        this.bus.$off('NewModal_'+this.EmitSeccion);

        this.bus.$on('Save_'+this.EmitSeccion,()=>
        {
           this.Guardar();
        });
        
        //Este es para modal
        this.bus.$on('NewModal_'+this.EmitSeccion,(data,Id)=> 
        {   
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false; 
             this.Limpiar();
            if (Id>0)
            {
                this.Equipo.IdEquipoCot=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
			this.Equipo.Tipo=this.pTipo;
            this.bus.$emit('Desbloqueo',false);
            
        });

		this.bus.$off("List_"+this.DatosTablaProveedor.EmitSeccionTabla);
        this.bus.$on("List_"+this.DatosTablaProveedor.EmitSeccionTabla,()=>{
            this.GetEquipoProveedor();
        });
		this.bus.$off("Delete_"+this.DatosTablaProveedor.EmitSeccionTabla);
        this.bus.$on("Delete_"+this.DatosTablaProveedor.EmitSeccionTabla,(Id)=>{
            this.BorrarProveedor(Id);
        });
       
    },
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
